<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">
        <span>{{ title }}</span>
    </h4>
</div>

<div class="modal-body">
    <app-feedback-execution
        [jobMatchId]="jobMatchId"
        [feedbackUserIdsList]="feedbackUserIdsList"
        [parentScheduleId]="parentScheduleId"
        [childScheduleId]="childScheduleId"
        (saveCallback)="refresh()"
        (completeFeedbackCallback)="refresh()"
        [feedbackType]="feedbackType"
        [externalCommentRequired]="false"
        [loginRequired]="true">
    </app-feedback-execution>
</div>
